export default __webpack_public_path__ + "static/media/Bitshrine.da9acda0.png";